export const navigate = (href: string) => {
  const container = document.querySelector('#landing');
  const element = document.querySelector(href);

  if (container && element) {
    container.scrollTo({
      top: element.getBoundingClientRect().top + container.scrollTop - 124,
      behavior: 'smooth',
    });
  }
};
